export default __webpack_public_path__ + "static/media/service-boarding.34214058.svg";